import { Delete, Edit, TramSharp } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import React, { useContext } from 'react'
import { DepartamentosContext } from '../../pages/catalogos/DepartamentosPage';

export const DepartamentoComponent = ({departamento}) => {
   const {modalAgregaDepartamento, setModalAgregaDepartamento,obtenerDepartamentos,modalEliminarDepartamento, setModalEliminarDepartamento, departamentoSel, setDepartamentoSel} = useContext(DepartamentosContext);

  return (
    <div
      style={{
        display:'flex',
        flexDirection:'row',
        justifyContent:'space-between',
        marginTop:6,
        backgroundColor:'white',
        borderRadius:10,
        padding:5,
        alignItems:'center'
      }}
    >
      <div
        style={{
          fontSize:14,
          display:'flex',
          flex:40
          
        }}
      >
        {departamento.descripcion}
      </div>
      <div
        style={{
          fontSize:14,
          display:'flex',
          flex:40
          
        }}
      >
        {departamento.direccion}
      </div>
      <div
        style={{
          fontSize:14,
          display:'flex',
          flex:40
          
        }}
      >
        {departamento.departamentoPadre}
      </div>
      <div>
        <IconButton
          onClick={() => {
            setDepartamentoSel(departamento)
            setModalAgregaDepartamento(true);
          }}
        >
        <Edit style={{color:'green'}} />
        </IconButton>
        <IconButton
          onClick={() => {
            setModalEliminarDepartamento(true);
            setDepartamentoSel(departamento)
          }}
        >
          <Delete style={{color:'red'}} />
        </IconButton>
      </div>
    </div>
  )
}
